import React from 'react';
import './SecondaryHeading.styles.scss';

function SecondaryHeading ({ isCentered, children }) {
    return (
        <h2 className={`secondary-heading ${isCentered ? 'secondary-heading--center' : ''}`}>
            {children}
        </h2>
    );
}

export default SecondaryHeading;